import "./Review.scss";

const Review = ({ review }) => {
  return (
    <div className="review">
      <div className="review__name">
        <p>{review.name}</p>
        <p>{new Date(review.date).toLocaleDateString()}</p>
      </div>
      <p className="review__comment">{review.review}</p>
    </div>
  );
};

export default Review;
